export const FAQS_LINK = 'https://paymentshield.helpshift.com/hc/en/';
export const TWITTER_LINK = 'http://twitter.com/paymentshield';
export const CONTACT_US_LINK =
  'https://quote.paymentshieldadviserhub.co.uk/contact-us';
export const TERMS_CONDITIONS_LINK =
  'https://www.paymentshield.co.uk/website-terms-conditions';
export const PRIVACY_POLICY_LINK =
  'https://www.paymentshield.co.uk/fair-processing-notice';
